import React = require('react');
import Carousel, { IcarouselData } from '../../../Carousel';
import AdmIcons from '../../../../../../../components/Icons/AdmIcons';
import { IMtaActions } from '../../../../../../../services/mta/models';
import { get } from 'lodash';
import Heap from '../../../../../../../helpers/Heap';

interface IPolicyCarousel {
  push: (route: string) => void;
  policy: any;
  status: string;
  upsellData: any;
  mtaActions: IMtaActions;
  isSingle: boolean;
}

export const PolicyCarousel = ({ push, policy, mtaActions, upsellData, isSingle }: IPolicyCarousel) => {

  const id = policy.id;
  const campaign = !get(upsellData, 'hasDiscount', false) ? get(upsellData, 'campaign', null) : null;

  const redirectToMakeAChange = () => {
    push(`/account/make-a-change/selection/${id}`);
  }

  const handleUpgradeYourCover = () => {
    redirectToMakeAChange();
  }

  const handleAddOptionalExtra = () => {
    push(`/account/redirect-to-mta-additional/${id}`)
  }

  const handleMakeAChange = () => {
    redirectToMakeAChange();
  }

  const handleUpsell = () => {
    mtaActions.setUpsellOptions({ campaign })
    push(`redirect-to-mta-upsell/${id}`)
    Heap.trackEvent('PolicyUpsell', policy, 'policy')
  }

  const optionalExtra = () => {
    return (
      <div style={{ color: '#FFFFFF' }} className={'p-carousel-content'} onClick={handleAddOptionalExtra}>
        <div style={{ fontWeight: 'bold' }}>Add an optional extra</div>
        <div style={{ fontSize: '14px' }}>See prices for optional extras</div>
        <div style={{ paddingTop: '10px' }}>
          <AdmIcons name={'cruise_cover'} color={'white'}/>
          <AdmIcons name={'winter_sports'} color={'white'}/>
          <AdmIcons name={'gadget_cover'} color={'white'}/>
        </div>
      </div>
    )
  }

  const upsellMarketing = () => {

    if (!isSingle) {
      return;
    }

    let campaignDisplay = (
      <>
        <div className={'upsell-discount'}>
          <div style={{ fontSize: '13px' }}>Unlimited trips for 12 months</div>
        </div>
      </>
    );

    if (campaign && campaign?.discount) {
      campaignDisplay = (
        <>
          <div className={'upsell-discount'}>
            <div style={{ fontSize: '13px' }}>When you switch use code {campaign.code}</div>
          </div>
        </>
      )
    }

    const price = upsellData?.difference ? upsellData.difference.toFixed(2) : '';
    const title = (campaign && campaign?.discount) ? 'Annual Multi-Trip Insurance' + (price ? ` for £${price}` : '') : 'Switch to Multi-Trip Insurance' + (price ? ` for £${price}` : '');

    return (
      <div className={'p-carousel-content'} onClick={handleUpsell}>
        <div style={{ fontWeight: 'bold', fontSize: '20px' }}
             className={'spacing'}>{title}
        </div>
        {campaignDisplay}
        <div>
          <AdmIcons name={'AnnualCalendar'} color={'admiral'} style={{ paddingTop: '5px' }}/>
          <AdmIcons name={'ShieldTicked'} color={'darkBlue'}/>
          <AdmIcons name={'Luggage'} color={'darkBlue'} style={{ paddingTop: '5px' }}/>
        </div>
      </div>
    )
  }

  const upgradeYourCover = () => {
    return (
      <div style={{ color: '#0045A0' }} className={'p-carousel-content'} onClick={handleUpgradeYourCover}>
        <div style={{ fontWeight: 'bold' }}>Upgrade your cover</div>
        <div style={{ fontSize: '14px' }}>Benefit from Gold or Platinum cover</div>
        <div style={{ paddingTop: '10px' }}>
          <AdmIcons name={'ShieldTicked'} color={'darkBlue'}/>
          <AdmIcons name={'ShieldTicked'} color={'gold'}/>
          <AdmIcons name={'ShieldTicked'} color={'platinum'}/>
        </div>
      </div>
    )
  }

  const makeAChange = () => {
    return (
      <div style={{ color: '#0045A0' }} className={'p-carousel-content'} onClick={handleMakeAChange}>
        <div style={{ fontWeight: 'bold' }}>Make a change</div>
        <div style={{ fontSize: '14px' }}>Update travellers, medical and more</div>
        <div style={{ paddingTop: '10px' }}>
          <AdmIcons name={'Admin'} color={'darkBlue'}/>
          <AdmIcons name={'People'} color={'darkBlue'}/>
          <AdmIcons name={'ImportantStatement'} color={'darkBlue'}/>
        </div>
      </div>
    )
  }

  const data: IcarouselData[] = [
    { component: makeAChange, backgroundColor: '#e0f2ff', navBackGround: '#b3c1cc' },
    { component: optionalExtra, backgroundColor: '#006fd3' },
  ];

  const tierChangeDisabled = policy.campaigns?.some(campaign => campaign.metadata?.prevent_mta_tier_change);
  if (!tierChangeDisabled) {
    data.unshift(
      { component: upgradeYourCover, backgroundColor: '#FFFFFF', navBackGround: '#cccccc' },
    )
  }

  const upsellDisabled = policy.campaigns?.some(campaign => campaign.metadata?.prevent_mta_upsell)
  if (isSingle && !upsellDisabled) {
    data.unshift(
      { component: upsellMarketing, backgroundColor: '#ffe699 ' }
    )
  }

  return (
    <Carousel data={data} animate={true}/>
  )
}
